import {
    CreateChartTemplateDataT,
    INDICATOR_TEMPLATE_STATUS,
    IndicatorTemplateStatusT,
} from '../types';
import {
    applyRootChartValues,
    updateAuthorizedFunctions,
    updateAuthorizedSoftwares,
} from './helpers';

import { ChartTemplateT } from '../CreateOrEditChartTemplate/hooks/getOneChartTemplate';
import { IndicatorBaseT } from 'business/definitions';
import { RootChartT } from '../CreateOrEditChartTemplate/hooks/getRootChart';

export type ManageChartTemplateState = IndicatorBaseT &
    CreateChartTemplateDataT & { shouldUpdateSourceChartParams: boolean };

type CustomizeChartTemplatePayload =
    | { description: string }
    | { preview: string }
    | { status: IndicatorTemplateStatusT }
    | { title: string };

export enum ManageChartTemplateActionType {
    ApplyRootChartValues = 'APPLY_ROOT_CHART_VALUES',
    CustomizeChartTemplate = 'CUSTOMIZE_CHART_TEMPLATE',
    InitializeChartTemplate = 'INITIALIZE_CHART_TEMPLATE',
    UpdateAuthorizedFunctions = 'UPDATE_AUTHORIZED_FUNCTIONS',
    UpdateAuthorizedSoftwares = 'UPDATE_AUTHORIZED_SOFTWARES',
}

export type ManageChartTemplateAction =
    | {
          type: ManageChartTemplateActionType.CustomizeChartTemplate;
          payload: CustomizeChartTemplatePayload;
      }
    | {
          type: ManageChartTemplateActionType.UpdateAuthorizedFunctions;
          newAuthorizedFunctions: string[];
      }
    | {
          type: ManageChartTemplateActionType.UpdateAuthorizedSoftwares;
          newAuthorizedSoftwares: string[];
      }
    | {
          type: ManageChartTemplateActionType.ApplyRootChartValues;
          rootChart: RootChartT;
          rootUrl: string;
          shouldUpdateTitle: boolean;
      }
    | {
          type: ManageChartTemplateActionType.InitializeChartTemplate;
          chartTemplate: ChartTemplateT;
      };

export const manageChartTemplateReducer = (
    state: ManageChartTemplateState,
    action: ManageChartTemplateAction,
): ManageChartTemplateState => {
    switch (action.type) {
        case ManageChartTemplateActionType.InitializeChartTemplate:
            return {
                ...action.chartTemplate,
                shouldUpdateSourceChartParams: false,
            };
        case ManageChartTemplateActionType.CustomizeChartTemplate:
            return {
                ...state,
                ...action.payload,
            };
        case ManageChartTemplateActionType.UpdateAuthorizedFunctions:
            return updateAuthorizedFunctions(
                state,
                action.newAuthorizedFunctions,
            );
        case ManageChartTemplateActionType.UpdateAuthorizedSoftwares:
            return updateAuthorizedSoftwares(
                state,
                action.newAuthorizedSoftwares,
            );
        case ManageChartTemplateActionType.ApplyRootChartValues:
            return applyRootChartValues(
                state,
                action.rootChart,
                action.rootUrl,
                action.shouldUpdateTitle,
            );
        default:
            return { ...state };
    }
};

export const INITIAL_CHART_TEMPLATE: ManageChartTemplateState = {
    authorizedFunctions: [],
    authorizedSoftwares: [],
    description: '',
    dimensions: [],
    filters: [],
    preview: '',
    metrics: [],
    rootUrl: '',
    settings: {},
    shouldUpdateSourceChartParams: false,
    status: INDICATOR_TEMPLATE_STATUS.DRAFT,
    title: '',
    vizType: 'table',
};
